import {
  canvasMedicalApiConfig,
  type CanvasMedicalRouteTypeMap,
} from 'canvas-medical-functions/client'
import { backendClient } from '@/utils/backendClient'

/** Canvas Medical gateway client (discover practitioners, practitioner resolve, patient resolve). */
export const canvasApi = backendClient<CanvasMedicalRouteTypeMap>(canvasMedicalApiConfig)
